import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import './EnviarConvite.css'; 
import { FcAlarmClock } from "react-icons/fc";
import Carregando from './Carregando';

import {
  collection,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  getDoc,
  query,
  where,
} from 'firebase/firestore';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const tenantId = localStorage.getItem('tenantId'); // Recupera o e-mail do usuário logado
let sanitizedClientId = '';
if (tenantId) {
  sanitizedClientId = tenantId;
}
const SIMULADOR_API_URL = `${apiUrl}/send-message?sanitizedClientId=${sanitizedClientId}`;


const EnviarConvite = () => {
  const [students, setStudents] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(true); // Novo estado para controlar a visibilidade do componente
  const tenantId = localStorage.getItem('tenantId') || 'unknownTenant';

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const contatosRef = collection(firestore, 'contatos');
        const q = query(contatosRef, where('status', '==', 'Pendente'), where('tenantId', '==', tenantId));
        const alunosSnapshot = await getDocs(q);
        const alunosData = alunosSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setStudents(alunosData);
        setIsLoading(false);
      } catch (error) {
        setError('Erro ao buscar contatos.');
        setIsLoading(false);
      }
    };
    fetchStudents();
  }, [tenantId]);

  // useEffect para limpar a mensagem de sucesso e fechar o componente após 3 segundos
  useEffect(() => {
    let timer;
    if (success) {
      timer = setTimeout(() => {
        setSuccess('');
        setIsVisible(false); // Fecha o componente após 3 segundos
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [success]);

  // useEffect para limpar a mensagem de erro após 5 segundos
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError('');
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [error]);

  const enviarConvite = async () => {
    try {
      // Usando o ID da pílula diretamente - Lembrar de bloquear a exclusão deste Id
      const pilulaRef = doc(firestore, 'pilulas', '1728521579467');
      const pilulaSnapshot = await getDoc(pilulaRef);
      const pilula = pilulaSnapshot.data();

      if (!pilula) {
        setError('Pílula não encontrada.');
        return;
      }


      const logPromises = students.map(async (student) => {
        await axios.post(`${SIMULADOR_API_URL}`, {
          phoneNumber: student.telefone,
          message: `*${pilula.titulo || ''}*\n\n${pilula.conteudo || ''}`,
        });

        // Atualiza o status do contato para "Convidado"
        await updateDoc(doc(firestore, 'contatos', student.id), {
          status: 'Convidado',
        });

        // Registra o envio do convite no log
        await addDoc(collection(firestore, 'logEnvioConvite'), {
          telefone: student.telefone,
          datahora: new Date(),
          tenantId: tenantId, // Inclui o tenantId no log de envio
        });
      });

      await Promise.all(logPromises);
      setSuccess('Convites enviados com sucesso!');
      setStudents([]); // Limpa a lista de estudantes pendentes após o envio
    } catch (error) {
      setError('Erro ao enviar convites: ' + error.message);
    }
  };

  // Se o componente não estiver visível, não renderiza nada
  if (!isVisible) {
    return null;
  }

  return (
    <div className="simuladorec-container">
      <h4>
        {isLoading
          ? <Carregando/>
          : `${students.length} Contato${students.length !== 1 ? 's' : ''} Novo${
              students.length !== 1 ? 's' : ''
            } `}
      </h4>
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
      {students.length > 0 ? (
        <>
          <button className="convidar-button" onClick={enviarConvite}>Convidar</button>          
          {/* <p>< FcAlarmClock size="30"/>Próxima Execução: 24 de out. de 2024 10:10.</p> */}
        </>
      ) : null}
    </div>
  );
}

export default EnviarConvite;
